import { Button, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(
  {
    buttonContainer: {
      "&:hover": {
        backgroundColor: "#1848FE",
        boxShadow: "inset 0px 0px 0px 1px #D0A73E"
      },
      backgroundColor: "#1848FE"
    },
    buttonText: {
      color: "#FFFFFF"
    },
    cardContainer: {
      backgroundColor: "#ffd0d680",
      borderLeftColor: "#EC5D77",
      borderLeftWidth: "8px"
    },
    cardContent: {
      display: "flex",
      justifyContent: "space-between"
    },
    text: {
      alignSelf: "center",
      color: "#EC5D77",
      fontSize: "1rem"
    },
    textemphasis: {
      fontWeight: 1000
    }
  },
  { name: "HomePage" }
);

interface SaleSubsidyErrorCardProps {
  number: number;
  saleErrorExportFileLink: string;
}

const SaleSubsidyErrorCard: React.FC<SaleSubsidyErrorCardProps> = props => {
  const { number, saleErrorExportFileLink } = props;
  const classes = useStyles(props);

  const download = (url, filename) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch(console.error);
  };
  return (
    <Card className={classes.cardContainer}>
      <CardContent className={classes.cardContent}>
        <span className={classes.text}>
          <span>{`The Sale Subsidy of`} </span>
          <span className={classes.textemphasis}>{`${number} ${
            number > 1 ? "items " : "item "
          }`}</span>
          <span>needs to be reviewed and updated</span>
        </span>

        <Button
          id="ExportProductListBtn"
          variant="contained"
          className={classes.buttonContainer}
          disabled={!saleErrorExportFileLink}
          onClick={() =>
            download(saleErrorExportFileLink, "SaleProductErrorList")
          }
        >
          <span className={classes.buttonText}>EXPORT PRODUCT LIST</span>
        </Button>
      </CardContent>
    </Card>
  );
};
SaleSubsidyErrorCard.displayName = "SaleSubsidyErrorCard";
export default SaleSubsidyErrorCard;
